import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReportingService } from 'src/app/reporting/shared/services/reporting.service';
import { FuelCellRemainingDashboard } from '../../interfaces/fuel-cell-remaining-dashboard';
import { FuelCellRemainingReport } from '../../interfaces/fuel-cell-remaining-report.interface';
import { Chart } from 'chart.js/auto';
import 'chartjs-plugin-datalabels';
import ChartDataLabels from 'chartjs-plugin-datalabels';





@Component({
  selector: 'avs-fuellcell-remaining-diagramm',
  standalone: false,
  templateUrl: './fuellcell-remaining-diagramm.component.html',
  styleUrl: './fuellcell-remaining-diagramm.component.css'
})
export class FuellcellRemainingDiagrammComponent implements OnInit, OnDestroy {


  public chart: any;
  public chartData?: FuelCellRemainingDashboard

  constructor(private reportingService: ReportingService) { }


  ngOnDestroy(): void {
    this.chart?.destroy();
  }

  ngOnInit(): void {
    this.getData();
  }

  public getDetails(): void {
    const fileType = 'csv';
    this.reportingService.getFuellCellRemainingDetailDataDownload(fileType)
      .subscribe((allProjectsData: FuelCellRemainingReport[]) => {       
        allProjectsData.forEach( projectData => {
          console.log(projectData.data);
          let base64StringA = projectData.data["fileContents"];
          let byteCharacters = atob(base64StringA);
          let byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
          let byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/'+ fileType});
          this.downloadBlob(blob, projectData.projectId);
       });
      });
  }
  private downloadBlob(blob: Blob, projectId:number): void {
    const fExtension = 'csv';
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    console.log('downloadBlob'+ url);

    link.download = `brennstoffzellen-fuellstände-project-${projectId}-${new Date().toISOString().split('T')[0]}.${fExtension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  private getDetailsDownload(): void {

  }


  private getData(): void {
    this.reportingService.getFuelCellRemainingDashboard().subscribe((x: FuelCellRemainingDashboard) => {
      this.chartData = x;
      this.createChart();
    })
  }

  private createChart(): void {
    this.chart = new Chart("FuelCellRemainingChart", {
      type: 'doughnut',
      data: {
        labels: ['> 50%', '> 10%', '<= 10%', 'keine Daten'],
        datasets: [{
/*           label: 'Brennstoffzellen Füllstand',
 */          data: [this.chartData?.highFuel, this.chartData?.mediumFuel, this.chartData?.lowFuel, (this.chartData?.totalDevices! - (this.chartData?.highFuel! + this.chartData?.mediumFuel! + this.chartData?.lowFuel!))],
          backgroundColor: [
            '#84c36c', /* grün */
            '#f7b731', /* gelb */
            '#d40c14',  /* rot */
            '#bdc3c7', /* grau */
          ],
          hoverBackgroundColor: [
            '#5ca43c',
            '#f39c12',
            '#bc0404',
            '#7f8c8d',
          ],
          hoverOffset: 0
        }],
      },
      options: {
        aspectRatio: 0.75,
        responsive: true,
        maintainAspectRatio: true,
        events: ['mousemove', 'mouseout', 'touchstart', 'touchmove'],
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
            },
          },
          datalabels: {
            font: {
              size: 13,
              weight: 'bold',
            },
            color: 'white',
            formatter: function (value: number, context: any) {
              const dataPoints = context.chart.data.datasets[0].data;
              function totalSum(total: number, datapoint: number) {
                return total + datapoint;
              }
              const totalValue = dataPoints.reduce(totalSum, 0);
              const percentageValue = (value / totalValue * 100).toFixed(1);

              return ` ${percentageValue}%`;
            },
          },
        },
      },
      plugins: [ChartDataLabels],
    });
  }
}